import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import Footer from "~components/footer";
import KeybindsCheatsheet from "~components/keybinds-cheatsheet/lazy";
import MobileDrawer from "~components/mobile-drawer/lazy";
import Navbar from "~components/navbar";
import siteConfig from "~config/site";
import meta from "~generated/meta.json";
import useKeybinds from "~hooks/use-keybinds";
import useNProgress from "~hooks/use-nprogress";
import { useCheatsheetSyncSetup } from "~store/global";
import { Box, Flex, useColorModeValue } from "@chakra-ui/react";
import Head from "next/head";
import { useRouter } from "next/router";
import { DefaultSeo, SocialProfileJsonLd } from "next-seo";

function Effects() {
  useCheatsheetSyncSetup();
  useKeybinds();
  useNProgress();
  return null;
}

var DefaultLayout = function DefaultLayout(props) {
  var children = props.children; // const bgColor = useColorModeValue("#885f5f", "gray.900");

  var bgColor = useColorModeValue("#fff", "gray.900");
  var color = useColorModeValue("#000", "#fff");
  var router = useRouter();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("meta", {
        content: "width=device-width, initial-scale=1.0",
        name: "viewport"
      }), meta.site.favicon.map(function (f, key) {
        return /*#__PURE__*/React.createElement(f.tag, _objectSpread({
          key: key
        }, f.attributes), null);
      })]
    }), /*#__PURE__*/_jsx(DefaultSeo, {
      canonical: siteConfig.siteUrl + (router.asPath || ""),
      defaultTitle: meta.site.seo.fallback.title,
      description: meta.site.seo.fallback.description,
      openGraph: {
        type: "website",
        site_name: meta.site.seo.siteName,
        images: [meta.site.seo.fallback.image]
      },
      twitter: {
        cardType: meta.site.seo.fallback.twitterCard,
        handle: meta.site.seo.twitterAccount,
        site: meta.site.seo.twitterAccount
      }
    }), /*#__PURE__*/_jsx(SocialProfileJsonLd, {
      name: meta.site.seo.siteName,
      sameAs: Object.values(meta.about.socialsJson),
      type: "person",
      url: siteConfig.siteUrl
    }), /*#__PURE__*/_jsxs(Flex, {
      backgroundColor: bgColor,
      flexDir: "column",
      minH: "100vh",
      children: [/*#__PURE__*/_jsx(Navbar, {}), /*#__PURE__*/_jsx(Box, {
        color: color,
        flexGrow: 1,
        children: children
      }, router.asPath), /*#__PURE__*/_jsx(Footer, {}), /*#__PURE__*/_jsx(MobileDrawer, {}), /*#__PURE__*/_jsx(KeybindsCheatsheet, {})]
    }), /*#__PURE__*/_jsx(Effects, {})]
  });
};

export default DefaultLayout;